import ServiceDetailsDefault from "src/components/common/Widgets/ServiceDetails/ServiceDetails";

const ServiceDetails = () => <ServiceDetailsDefault />;

export default ServiceDetails;
